/*
 * This file was generated with: pnpm generate:icons
 */
import { ReactComponent as AstraZenecaLogo } from '@csp/csp-web-icons/src/lib/assets/icons/AstraZeneca-logo.svg';
import { ReactComponent as AstraZeneca } from '@csp/csp-web-icons/src/lib/assets/icons/AstraZeneca.svg';
import { ReactComponent as AccordionDown } from '@csp/csp-web-icons/src/lib/assets/icons/accordion-down.svg';
import { ReactComponent as AccordionLeft } from '@csp/csp-web-icons/src/lib/assets/icons/accordion-left.svg';
import { ReactComponent as AddLocation } from '@csp/csp-web-icons/src/lib/assets/icons/add-location.svg';
import { ReactComponent as Address } from '@csp/csp-web-icons/src/lib/assets/icons/address.svg';
import { ReactComponent as Advice } from '@csp/csp-web-icons/src/lib/assets/icons/advice.svg';
import { ReactComponent as AllDocuments } from '@csp/csp-web-icons/src/lib/assets/icons/all-documents.svg';
import { ReactComponent as AppointmentsDown } from '@csp/csp-web-icons/src/lib/assets/icons/appointments-down.svg';
import { ReactComponent as AppointmentsUp } from '@csp/csp-web-icons/src/lib/assets/icons/appointments-up.svg';
import { ReactComponent as ArrowBack } from '@csp/csp-web-icons/src/lib/assets/icons/arrow-back.svg';
import { ReactComponent as ArrowForward } from '@csp/csp-web-icons/src/lib/assets/icons/arrow-forward.svg';
import { ReactComponent as Arrow } from '@csp/csp-web-icons/src/lib/assets/icons/arrow.svg';
import { ReactComponent as BackRound } from '@csp/csp-web-icons/src/lib/assets/icons/back-round.svg';
import { ReactComponent as Back } from '@csp/csp-web-icons/src/lib/assets/icons/back.svg';
import { ReactComponent as Barcode } from '@csp/csp-web-icons/src/lib/assets/icons/barcode.svg';
import { ReactComponent as BatteryFull } from '@csp/csp-web-icons/src/lib/assets/icons/battery-full.svg';
import { ReactComponent as BatteryLow } from '@csp/csp-web-icons/src/lib/assets/icons/battery-low.svg';
import { ReactComponent as BatteryMedium } from '@csp/csp-web-icons/src/lib/assets/icons/battery-medium.svg';
import { ReactComponent as BatteryNodata } from '@csp/csp-web-icons/src/lib/assets/icons/battery-nodata.svg';
import { ReactComponent as Battery } from '@csp/csp-web-icons/src/lib/assets/icons/battery.svg';
import { ReactComponent as BrokenLink } from '@csp/csp-web-icons/src/lib/assets/icons/broken-link.svg';
import { ReactComponent as CalendarRound } from '@csp/csp-web-icons/src/lib/assets/icons/calendar-round.svg';
import { ReactComponent as Calendar } from '@csp/csp-web-icons/src/lib/assets/icons/calendar.svg';
import { ReactComponent as Cancel } from '@csp/csp-web-icons/src/lib/assets/icons/cancel.svg';
import { ReactComponent as CheckRound } from '@csp/csp-web-icons/src/lib/assets/icons/check-round.svg';
import { ReactComponent as Check } from '@csp/csp-web-icons/src/lib/assets/icons/check.svg';
import { ReactComponent as ChevronDownRound } from '@csp/csp-web-icons/src/lib/assets/icons/chevron-down-round.svg';
import { ReactComponent as ChevronDown } from '@csp/csp-web-icons/src/lib/assets/icons/chevron-down.svg';
import { ReactComponent as ChevronLeftRound } from '@csp/csp-web-icons/src/lib/assets/icons/chevron-left-round.svg';
import { ReactComponent as ChevronRightRound } from '@csp/csp-web-icons/src/lib/assets/icons/chevron-right-round.svg';
import { ReactComponent as ChevronUpRound } from '@csp/csp-web-icons/src/lib/assets/icons/chevron-up-round.svg';
import { ReactComponent as ChevronUp } from '@csp/csp-web-icons/src/lib/assets/icons/chevron-up.svg';
import { ReactComponent as Clock } from '@csp/csp-web-icons/src/lib/assets/icons/clock.svg';
import { ReactComponent as Close } from '@csp/csp-web-icons/src/lib/assets/icons/close.svg';
import { ReactComponent as Compliance } from '@csp/csp-web-icons/src/lib/assets/icons/compliance.svg';
import { ReactComponent as ContactRound } from '@csp/csp-web-icons/src/lib/assets/icons/contact-round.svg';
import { ReactComponent as Contact } from '@csp/csp-web-icons/src/lib/assets/icons/contact.svg';
import { ReactComponent as Contract } from '@csp/csp-web-icons/src/lib/assets/icons/contract.svg';
import { ReactComponent as Csv } from '@csp/csp-web-icons/src/lib/assets/icons/csv.svg';
import { ReactComponent as Delete } from '@csp/csp-web-icons/src/lib/assets/icons/delete.svg';
import { ReactComponent as DesktopAccessDisabled } from '@csp/csp-web-icons/src/lib/assets/icons/desktop-access-disabled.svg';
import { ReactComponent as DesktopWindows } from '@csp/csp-web-icons/src/lib/assets/icons/desktop-windows.svg';
import { ReactComponent as Details } from '@csp/csp-web-icons/src/lib/assets/icons/details.svg';
import { ReactComponent as DocumentEmpty } from '@csp/csp-web-icons/src/lib/assets/icons/document-empty.svg';
import { ReactComponent as Document } from '@csp/csp-web-icons/src/lib/assets/icons/document.svg';
import { ReactComponent as Download } from '@csp/csp-web-icons/src/lib/assets/icons/download.svg';
import { ReactComponent as Drawer } from '@csp/csp-web-icons/src/lib/assets/icons/drawer.svg';
import { ReactComponent as EditData } from '@csp/csp-web-icons/src/lib/assets/icons/edit-data.svg';
import { ReactComponent as ErrorCircle } from '@csp/csp-web-icons/src/lib/assets/icons/error-circle.svg';
import { ReactComponent as Error } from '@csp/csp-web-icons/src/lib/assets/icons/error.svg';
import { ReactComponent as EvinovaLogo } from '@csp/csp-web-icons/src/lib/assets/icons/evinova-logo.svg';
import { ReactComponent as Evinova } from '@csp/csp-web-icons/src/lib/assets/icons/evinova.svg';
import { ReactComponent as ExostarLogo } from '@csp/csp-web-icons/src/lib/assets/icons/exostar-logo.svg';
import { ReactComponent as Feedback } from '@csp/csp-web-icons/src/lib/assets/icons/feedback.svg';
import { ReactComponent as File } from '@csp/csp-web-icons/src/lib/assets/icons/file.svg';
import { ReactComponent as Filter } from '@csp/csp-web-icons/src/lib/assets/icons/filter.svg';
import { ReactComponent as FirstPage } from '@csp/csp-web-icons/src/lib/assets/icons/first-page.svg';
import { ReactComponent as Folder } from '@csp/csp-web-icons/src/lib/assets/icons/folder.svg';
import { ReactComponent as Globe } from '@csp/csp-web-icons/src/lib/assets/icons/globe.svg';
import { ReactComponent as GridMenu } from '@csp/csp-web-icons/src/lib/assets/icons/grid-menu.svg';
import { ReactComponent as HealthEvent } from '@csp/csp-web-icons/src/lib/assets/icons/health-event.svg';
import { ReactComponent as HomeVisit } from '@csp/csp-web-icons/src/lib/assets/icons/home-visit.svg';
import { ReactComponent as IcfLocalPlaceholderNonTranslated } from '@csp/csp-web-icons/src/lib/assets/icons/icf-local-placeholder-non-translated.svg';
import { ReactComponent as IcfLocalPlaceholderTranslated } from '@csp/csp-web-icons/src/lib/assets/icons/icf-local-placeholder-translated.svg';
import { ReactComponent as IcfLocalTemplateNonTranslated } from '@csp/csp-web-icons/src/lib/assets/icons/icf-local-template-non-translated.svg';
import { ReactComponent as IcfLocalTemplateTranslated } from '@csp/csp-web-icons/src/lib/assets/icons/icf-local-template-translated.svg';
import { ReactComponent as IcfTemplateMaster } from '@csp/csp-web-icons/src/lib/assets/icons/icf-template-master.svg';
import { ReactComponent as ImportantDevices } from '@csp/csp-web-icons/src/lib/assets/icons/important-devices.svg';
import { ReactComponent as InProcess } from '@csp/csp-web-icons/src/lib/assets/icons/in-process.svg';
import { ReactComponent as InfoFilled } from '@csp/csp-web-icons/src/lib/assets/icons/info-filled.svg';
import { ReactComponent as Info } from '@csp/csp-web-icons/src/lib/assets/icons/info.svg';
import { ReactComponent as Invalid } from '@csp/csp-web-icons/src/lib/assets/icons/invalid.svg';
import { ReactComponent as LastConnection } from '@csp/csp-web-icons/src/lib/assets/icons/last-connection.svg';
import { ReactComponent as LastPage } from '@csp/csp-web-icons/src/lib/assets/icons/last-page.svg';
import { ReactComponent as Lock } from '@csp/csp-web-icons/src/lib/assets/icons/lock.svg';
import { ReactComponent as Login } from '@csp/csp-web-icons/src/lib/assets/icons/login.svg';
import { ReactComponent as Logout } from '@csp/csp-web-icons/src/lib/assets/icons/logout.svg';
import { ReactComponent as Mail } from '@csp/csp-web-icons/src/lib/assets/icons/mail.svg';
import { ReactComponent as MedicationPill } from '@csp/csp-web-icons/src/lib/assets/icons/medication-pill.svg';
import { ReactComponent as MedicationRound } from '@csp/csp-web-icons/src/lib/assets/icons/medication-round.svg';
import { ReactComponent as Medication } from '@csp/csp-web-icons/src/lib/assets/icons/medication.svg';
import { ReactComponent as Menu } from '@csp/csp-web-icons/src/lib/assets/icons/menu.svg';
import { ReactComponent as Minus } from '@csp/csp-web-icons/src/lib/assets/icons/minus.svg';
import { ReactComponent as MissingDevice } from '@csp/csp-web-icons/src/lib/assets/icons/missing-device.svg';
import { ReactComponent as Mov } from '@csp/csp-web-icons/src/lib/assets/icons/mov.svg';
import { ReactComponent as NewPatientUp } from '@csp/csp-web-icons/src/lib/assets/icons/new-patient-up.svg';
import { ReactComponent as NewTabRound } from '@csp/csp-web-icons/src/lib/assets/icons/new-tab-round.svg';
import { ReactComponent as NewTab } from '@csp/csp-web-icons/src/lib/assets/icons/new-tab.svg';
import { ReactComponent as NoApp } from '@csp/csp-web-icons/src/lib/assets/icons/no-app.svg';
import { ReactComponent as NotificationCircle } from '@csp/csp-web-icons/src/lib/assets/icons/notification-circle.svg';
import { ReactComponent as NotificationOutlined } from '@csp/csp-web-icons/src/lib/assets/icons/notification-outlined.svg';
import { ReactComponent as NotificationPersonFilled } from '@csp/csp-web-icons/src/lib/assets/icons/notification-person-filled.svg';
import { ReactComponent as PatientAdd } from '@csp/csp-web-icons/src/lib/assets/icons/patient-add.svg';
import { ReactComponent as Patients } from '@csp/csp-web-icons/src/lib/assets/icons/patients.svg';
import { ReactComponent as Pdf } from '@csp/csp-web-icons/src/lib/assets/icons/pdf.svg';
import { ReactComponent as Pencil } from '@csp/csp-web-icons/src/lib/assets/icons/pencil.svg';
import { ReactComponent as PersonFilled } from '@csp/csp-web-icons/src/lib/assets/icons/person-filled.svg';
import { ReactComponent as Person } from '@csp/csp-web-icons/src/lib/assets/icons/person.svg';
import { ReactComponent as Pin } from '@csp/csp-web-icons/src/lib/assets/icons/pin.svg';
import { ReactComponent as PlusRound } from '@csp/csp-web-icons/src/lib/assets/icons/plus-round.svg';
import { ReactComponent as Plus } from '@csp/csp-web-icons/src/lib/assets/icons/plus.svg';
import { ReactComponent as Png } from '@csp/csp-web-icons/src/lib/assets/icons/png.svg';
import { ReactComponent as Ppt } from '@csp/csp-web-icons/src/lib/assets/icons/ppt.svg';
import { ReactComponent as ProfileAvatar } from '@csp/csp-web-icons/src/lib/assets/icons/profile-avatar.svg';
import { ReactComponent as Profile } from '@csp/csp-web-icons/src/lib/assets/icons/profile.svg';
import { ReactComponent as Questionnaire } from '@csp/csp-web-icons/src/lib/assets/icons/questionnaire.svg';
import { ReactComponent as Refresh } from '@csp/csp-web-icons/src/lib/assets/icons/refresh.svg';
import { ReactComponent as ReportedEvent } from '@csp/csp-web-icons/src/lib/assets/icons/reported-event.svg';
import { ReactComponent as Reported } from '@csp/csp-web-icons/src/lib/assets/icons/reported.svg';
import { ReactComponent as Role } from '@csp/csp-web-icons/src/lib/assets/icons/role.svg';
import { ReactComponent as SampleCollection } from '@csp/csp-web-icons/src/lib/assets/icons/sample-collection.svg';
import { ReactComponent as Schedule } from '@csp/csp-web-icons/src/lib/assets/icons/schedule.svg';
import { ReactComponent as Search } from '@csp/csp-web-icons/src/lib/assets/icons/search.svg';
import { ReactComponent as Settings } from '@csp/csp-web-icons/src/lib/assets/icons/settings.svg';
import { ReactComponent as Site } from '@csp/csp-web-icons/src/lib/assets/icons/site.svg';
import { ReactComponent as SmartphoneRound } from '@csp/csp-web-icons/src/lib/assets/icons/smartphone-round.svg';
import { ReactComponent as Smartphone } from '@csp/csp-web-icons/src/lib/assets/icons/smartphone.svg';
import { ReactComponent as SortByDown } from '@csp/csp-web-icons/src/lib/assets/icons/sort-by-down.svg';
import { ReactComponent as SortByUp } from '@csp/csp-web-icons/src/lib/assets/icons/sort-by-up.svg';
import { ReactComponent as Status } from '@csp/csp-web-icons/src/lib/assets/icons/status.svg';
import { ReactComponent as StudyHelp } from '@csp/csp-web-icons/src/lib/assets/icons/study-help.svg';
import { ReactComponent as StudyProgress } from '@csp/csp-web-icons/src/lib/assets/icons/study-progress.svg';
import { ReactComponent as StudyStatusRound } from '@csp/csp-web-icons/src/lib/assets/icons/study-status-round.svg';
import { ReactComponent as StudyStatus } from '@csp/csp-web-icons/src/lib/assets/icons/study-status.svg';
import { ReactComponent as Submitted } from '@csp/csp-web-icons/src/lib/assets/icons/submitted.svg';
import { ReactComponent as Success } from '@csp/csp-web-icons/src/lib/assets/icons/success.svg';
import { ReactComponent as Sunglasses } from '@csp/csp-web-icons/src/lib/assets/icons/sunglasses.svg';
import { ReactComponent as SupportFilled } from '@csp/csp-web-icons/src/lib/assets/icons/support-filled.svg';
import { ReactComponent as Support } from '@csp/csp-web-icons/src/lib/assets/icons/support.svg';
import { ReactComponent as Team } from '@csp/csp-web-icons/src/lib/assets/icons/team.svg';
import { ReactComponent as TemporaryInformedConsent } from '@csp/csp-web-icons/src/lib/assets/icons/temporary-informed-consent.svg';
import { ReactComponent as TermsConditions } from '@csp/csp-web-icons/src/lib/assets/icons/terms-conditions.svg';
import { ReactComponent as Timeline } from '@csp/csp-web-icons/src/lib/assets/icons/timeline.svg';
import { ReactComponent as Timer } from '@csp/csp-web-icons/src/lib/assets/icons/timer.svg';
import { ReactComponent as UnfoldMore } from '@csp/csp-web-icons/src/lib/assets/icons/unfold-more.svg';
import { ReactComponent as UnifyLogoBackground } from '@csp/csp-web-icons/src/lib/assets/icons/unify-logo-background.svg';
import { ReactComponent as UnifyLogoOnly } from '@csp/csp-web-icons/src/lib/assets/icons/unify-logo-only.svg';
import { ReactComponent as UnifyWithIcon } from '@csp/csp-web-icons/src/lib/assets/icons/unify-with-icon.svg';
import { ReactComponent as Upload } from '@csp/csp-web-icons/src/lib/assets/icons/upload.svg';
import { ReactComponent as Verified } from '@csp/csp-web-icons/src/lib/assets/icons/verified.svg';
import { ReactComponent as VisibilityOff } from '@csp/csp-web-icons/src/lib/assets/icons/visibility-off.svg';
import { ReactComponent as Visibility } from '@csp/csp-web-icons/src/lib/assets/icons/visibility.svg';
import { ReactComponent as WarningRound } from '@csp/csp-web-icons/src/lib/assets/icons/warning-round.svg';
import { ReactComponent as WarningUp } from '@csp/csp-web-icons/src/lib/assets/icons/warning-up.svg';
import { ReactComponent as Warning } from '@csp/csp-web-icons/src/lib/assets/icons/warning.svg';
import { ReactComponent as Water } from '@csp/csp-web-icons/src/lib/assets/icons/water.svg';
import { createBrandedIcon } from './createBrandedIcon';

export const BrandedAstraZenecaLogoIcon = createBrandedIcon(AstraZenecaLogo);

export const BrandedAstraZenecaIcon = createBrandedIcon(AstraZeneca);

export const BrandedAccordionDownIcon = createBrandedIcon(AccordionDown);

export const BrandedAccordionLeftIcon = createBrandedIcon(AccordionLeft);

export const BrandedAddLocationIcon = createBrandedIcon(AddLocation);

export const BrandedAddressIcon = createBrandedIcon(Address);

export const BrandedAdviceIcon = createBrandedIcon(Advice);

export const BrandedAllDocumentsIcon = createBrandedIcon(AllDocuments);

export const BrandedAppointmentsDownIcon = createBrandedIcon(AppointmentsDown);

export const BrandedAppointmentsUpIcon = createBrandedIcon(AppointmentsUp);

export const BrandedArrowBackIcon = createBrandedIcon(ArrowBack);

export const BrandedArrowForwardIcon = createBrandedIcon(ArrowForward);

export const BrandedArrowIcon = createBrandedIcon(Arrow);

export const BrandedBackRoundIcon = createBrandedIcon(BackRound);

export const BrandedBackIcon = createBrandedIcon(Back);

export const BrandedBarcodeIcon = createBrandedIcon(Barcode);

export const BrandedBatteryFullIcon = createBrandedIcon(BatteryFull);

export const BrandedBatteryLowIcon = createBrandedIcon(BatteryLow);

export const BrandedBatteryMediumIcon = createBrandedIcon(BatteryMedium);

export const BrandedBatteryNodataIcon = createBrandedIcon(BatteryNodata);

export const BrandedBatteryIcon = createBrandedIcon(Battery);

export const BrandedBrokenLinkIcon = createBrandedIcon(BrokenLink);

export const BrandedCalendarRoundIcon = createBrandedIcon(CalendarRound);

export const BrandedCalendarIcon = createBrandedIcon(Calendar);

export const BrandedCancelIcon = createBrandedIcon(Cancel);

export const BrandedCheckRoundIcon = createBrandedIcon(CheckRound);

export const BrandedCheckIcon = createBrandedIcon(Check);

export const BrandedChevronDownRoundIcon = createBrandedIcon(ChevronDownRound);

export const BrandedChevronDownIcon = createBrandedIcon(ChevronDown);

export const BrandedChevronLeftRoundIcon = createBrandedIcon(ChevronLeftRound);

export const BrandedChevronRightRoundIcon = createBrandedIcon(ChevronRightRound);

export const BrandedChevronUpRoundIcon = createBrandedIcon(ChevronUpRound);

export const BrandedChevronUpIcon = createBrandedIcon(ChevronUp);

export const BrandedClockIcon = createBrandedIcon(Clock);

export const BrandedCloseIcon = createBrandedIcon(Close);

export const BrandedComplianceIcon = createBrandedIcon(Compliance);

export const BrandedContactRoundIcon = createBrandedIcon(ContactRound);

export const BrandedContactIcon = createBrandedIcon(Contact);

export const BrandedContractIcon = createBrandedIcon(Contract);

export const BrandedCsvIcon = createBrandedIcon(Csv);

export const BrandedDeleteIcon = createBrandedIcon(Delete);

export const BrandedDesktopAccessDisabledIcon = createBrandedIcon(DesktopAccessDisabled);

export const BrandedDesktopWindowsIcon = createBrandedIcon(DesktopWindows);

export const BrandedDetailsIcon = createBrandedIcon(Details);

export const BrandedDocumentEmptyIcon = createBrandedIcon(DocumentEmpty);

export const BrandedDocumentIcon = createBrandedIcon(Document);

export const BrandedDownloadIcon = createBrandedIcon(Download);

export const BrandedDrawerIcon = createBrandedIcon(Drawer);

export const BrandedEditDataIcon = createBrandedIcon(EditData);

export const BrandedErrorCircleIcon = createBrandedIcon(ErrorCircle);

export const BrandedErrorIcon = createBrandedIcon(Error);

export const BrandedEvinovaLogoIcon = createBrandedIcon(EvinovaLogo);

export const BrandedEvinovaIcon = createBrandedIcon(Evinova);

export const BrandedExostarLogoIcon = createBrandedIcon(ExostarLogo);

export const BrandedFeedbackIcon = createBrandedIcon(Feedback);

export const BrandedFileIcon = createBrandedIcon(File);

export const BrandedFilterIcon = createBrandedIcon(Filter);

export const BrandedFirstPageIcon = createBrandedIcon(FirstPage);

export const BrandedFolderIcon = createBrandedIcon(Folder);

export const BrandedGlobeIcon = createBrandedIcon(Globe);

export const BrandedGridMenuIcon = createBrandedIcon(GridMenu);

export const BrandedHealthEventIcon = createBrandedIcon(HealthEvent);

export const BrandedHomeVisitIcon = createBrandedIcon(HomeVisit);

export const BrandedIcfLocalPlaceholderNonTranslatedIcon = createBrandedIcon(IcfLocalPlaceholderNonTranslated);

export const BrandedIcfLocalPlaceholderTranslatedIcon = createBrandedIcon(IcfLocalPlaceholderTranslated);

export const BrandedIcfLocalTemplateNonTranslatedIcon = createBrandedIcon(IcfLocalTemplateNonTranslated);

export const BrandedIcfLocalTemplateTranslatedIcon = createBrandedIcon(IcfLocalTemplateTranslated);

export const BrandedIcfTemplateMasterIcon = createBrandedIcon(IcfTemplateMaster);

export const BrandedImportantDevicesIcon = createBrandedIcon(ImportantDevices);

export const BrandedInProcessIcon = createBrandedIcon(InProcess);

export const BrandedInfoFilledIcon = createBrandedIcon(InfoFilled);

export const BrandedInfoIcon = createBrandedIcon(Info);

export const BrandedInvalidIcon = createBrandedIcon(Invalid);

export const BrandedLastConnectionIcon = createBrandedIcon(LastConnection);

export const BrandedLastPageIcon = createBrandedIcon(LastPage);

export const BrandedLockIcon = createBrandedIcon(Lock);

export const BrandedLoginIcon = createBrandedIcon(Login);

export const BrandedLogoutIcon = createBrandedIcon(Logout);

export const BrandedMailIcon = createBrandedIcon(Mail);

export const BrandedMedicationPillIcon = createBrandedIcon(MedicationPill);

export const BrandedMedicationRoundIcon = createBrandedIcon(MedicationRound);

export const BrandedMedicationIcon = createBrandedIcon(Medication);

export const BrandedMenuIcon = createBrandedIcon(Menu);

export const BrandedMinusIcon = createBrandedIcon(Minus);

export const BrandedMissingDeviceIcon = createBrandedIcon(MissingDevice);

export const BrandedMovIcon = createBrandedIcon(Mov);

export const BrandedNewPatientUpIcon = createBrandedIcon(NewPatientUp);

export const BrandedNewTabRoundIcon = createBrandedIcon(NewTabRound);

export const BrandedNewTabIcon = createBrandedIcon(NewTab);

export const BrandedNoAppIcon = createBrandedIcon(NoApp);

export const BrandedNotificationCircleIcon = createBrandedIcon(NotificationCircle);

export const BrandedNotificationOutlinedIcon = createBrandedIcon(NotificationOutlined);

export const BrandedNotificationPersonFilledIcon = createBrandedIcon(NotificationPersonFilled);

export const BrandedPatientAddIcon = createBrandedIcon(PatientAdd);

export const BrandedPatientsIcon = createBrandedIcon(Patients);

export const BrandedPdfIcon = createBrandedIcon(Pdf);

export const BrandedPencilIcon = createBrandedIcon(Pencil);

export const BrandedPersonFilledIcon = createBrandedIcon(PersonFilled);

export const BrandedPersonIcon = createBrandedIcon(Person);

export const BrandedPinIcon = createBrandedIcon(Pin);

export const BrandedPlusRoundIcon = createBrandedIcon(PlusRound);

export const BrandedPlusIcon = createBrandedIcon(Plus);

export const BrandedPngIcon = createBrandedIcon(Png);

export const BrandedPptIcon = createBrandedIcon(Ppt);

export const BrandedProfileAvatarIcon = createBrandedIcon(ProfileAvatar);

export const BrandedProfileIcon = createBrandedIcon(Profile);

export const BrandedQuestionnaireIcon = createBrandedIcon(Questionnaire);

export const BrandedRefreshIcon = createBrandedIcon(Refresh);

export const BrandedReportedEventIcon = createBrandedIcon(ReportedEvent);

export const BrandedReportedIcon = createBrandedIcon(Reported);

export const BrandedRoleIcon = createBrandedIcon(Role);

export const BrandedSampleCollectionIcon = createBrandedIcon(SampleCollection);

export const BrandedScheduleIcon = createBrandedIcon(Schedule);

export const BrandedSearchIcon = createBrandedIcon(Search);

export const BrandedSettingsIcon = createBrandedIcon(Settings);

export const BrandedSiteIcon = createBrandedIcon(Site);

export const BrandedSmartphoneRoundIcon = createBrandedIcon(SmartphoneRound);

export const BrandedSmartphoneIcon = createBrandedIcon(Smartphone);

export const BrandedSortByDownIcon = createBrandedIcon(SortByDown);

export const BrandedSortByUpIcon = createBrandedIcon(SortByUp);

export const BrandedStatusIcon = createBrandedIcon(Status);

export const BrandedStudyHelpIcon = createBrandedIcon(StudyHelp);

export const BrandedStudyProgressIcon = createBrandedIcon(StudyProgress);

export const BrandedStudyStatusRoundIcon = createBrandedIcon(StudyStatusRound);

export const BrandedStudyStatusIcon = createBrandedIcon(StudyStatus);

export const BrandedSubmittedIcon = createBrandedIcon(Submitted);

export const BrandedSuccessIcon = createBrandedIcon(Success);

export const BrandedSunglassesIcon = createBrandedIcon(Sunglasses);

export const BrandedSupportFilledIcon = createBrandedIcon(SupportFilled);

export const BrandedSupportIcon = createBrandedIcon(Support);

export const BrandedTeamIcon = createBrandedIcon(Team);

export const BrandedTemporaryInformedConsentIcon = createBrandedIcon(TemporaryInformedConsent);

export const BrandedTermsConditionsIcon = createBrandedIcon(TermsConditions);

export const BrandedTimelineIcon = createBrandedIcon(Timeline);

export const BrandedTimerIcon = createBrandedIcon(Timer);

export const BrandedUnfoldMoreIcon = createBrandedIcon(UnfoldMore);

export const BrandedUnifyLogoBackgroundIcon = createBrandedIcon(UnifyLogoBackground);

export const BrandedUnifyLogoOnlyIcon = createBrandedIcon(UnifyLogoOnly);

export const BrandedUnifyWithIconIcon = createBrandedIcon(UnifyWithIcon);

export const BrandedUploadIcon = createBrandedIcon(Upload);

export const BrandedVerifiedIcon = createBrandedIcon(Verified);

export const BrandedVisibilityOffIcon = createBrandedIcon(VisibilityOff);

export const BrandedVisibilityIcon = createBrandedIcon(Visibility);

export const BrandedWarningRoundIcon = createBrandedIcon(WarningRound);

export const BrandedWarningUpIcon = createBrandedIcon(WarningUp);

export const BrandedWarningIcon = createBrandedIcon(Warning);

export const BrandedWaterIcon = createBrandedIcon(Water);
